import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from 'components/CustomButtons/Button.js';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = (theme) => ({
  root: {
    '& .MuiFormControl-root': {
      margin: theme.spacing(2),
      width: 200,
      marginLeft: '1px',
    },
  },
  rootCircular: {
    flexGrow: 1,
    backgroundColor: '#f1f1f2',
  },
  green: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    width: '100% !important'
  },
  buttonAlign: {
    float: 'right',
  },
});

// preparando refatoração para componente funcional
// const [dateFrom, setDateFrom] = useState(null);
// const handleChangeDateFrom = (dateFrom) => setDateFrom(dateFrom);
// const [dateTo, setDateTo] = useState(null);
// const handleChangeDateTo = (dateTo) => setDateTo(dateTo);
// const [circular, setCircular] = useState(false);
// const handleCircular = () => setCircular(!circular);

class SearchOperations extends Component {
  state = {
    code: '',
    usuario: '',
    encomenda: '',
    porta: '',
    dateFrom: null,
    dateTo: null,
    circular: false,
    finalValue: '',
    finalField: '',
    setEncomenda: false,
  };

  handleClearInput = () => {
    this.setState({
      code: '',
      usuario: '',
      encomenda: '',
      porta: '',
      dateFrom: null,
      dateTo: null,
      finalValue: '',
      finalField: '',
      setEncomenda: false,
    });
  };

  handleChange = (event) => {
    const e = event.target.id ? event.target.id : event.target.name;
    const { value } = event.target;

    switch (e) {
      case 'code':
        this.setState({ code: value, finalValue: value, finalField: e });
        break;
      case 'usuario':
        this.setState({ usuario: value, finalValue: value, finalField: e });
        break;
      case 'parametro1':
        this.setState({ porta: Number(value), finalValue: Number(value), finalField: e });
        break;
      case 'encomenda':
        this.setState({ encomenda: value, finalValue: value, finalField: e, setEncomenda: true });
        break;
    }
  };

  handleChangeDateFrom = (dateFrom) => {
    this.setState({ dateFrom, finalField: 'dateFrom' });
  };

  handleChangeDateTo = (dateTo) => {
    this.setState({ dateTo, finalField: 'dateTo' });
  };

  handleFilterTable = () => {
    const { finalField, finalValue, dateFrom, dateTo, code, usuario, porta } = this.state;
    this.props.filterTable(finalField, finalValue, dateFrom, dateTo, code, usuario, porta);
    this.handleClearInput();
  };

  render() {
    const { show, classes, codeAndOperation } = this.props;
    let { dateFrom, dateTo, setEncomenda, code } = this.state;

    if (!show) return null;

    return (
      <div className={classes.green}>
        <form className={classes.root} noValidate autoComplete="off">
          <h5>PESQUISAR OPERAÇÕES</h5>

          <GridContainer>
            <GridItem xs={12} sm={6} md={3}>
              <TextField
                className={classes.green}
                select
                disabled={setEncomenda}
                label="Operação"
                name="code"
                id="code"
                value={code}
                onChange={this.handleChange}
              >
                {codeAndOperation.map(({ codigo, operacao }) => (
                  <MenuItem key={codigo} value={codigo}>
                    {codigo + ' - ' + operacao}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>

            <GridItem xs={12} sm={6} md={3}>
              <FormControl className={classes.green}>
                <InputLabel htmlFor="encomenda">Usuário</InputLabel>
                <Input
                  onChange={this.handleChange}
                  name="usuario"
                  id="usuario"
                  disabled={setEncomenda}
                />
              </FormControl>
            </GridItem>

            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <GridItem xs={12} sm={6} md={3}>
                <KeyboardDatePicker
                  disabled={setEncomenda}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="from"
                  label="Data inicial:"
                  value={dateFrom}
                  onChange={this.handleChangeDateFrom}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={6} md={3}>
                <KeyboardDatePicker
                  disabled={setEncomenda}
                  disableToolbar
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="to"
                  label="Data final:"
                  value={dateTo}
                  onChange={this.handleChangeDateTo}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </GridItem>
            </MuiPickersUtilsProvider>

            <GridItem xs={12} sm={6} md={3}>
              <FormControl className={classes.green}>
                <InputLabel htmlFor="parametro1">Porta</InputLabel>
                <Input
                  onChange={this.handleChange}
                  name="parametro1"
                  id="parametro1"
                  disabled={setEncomenda}
                />
              </FormControl>
            </GridItem>

            <GridItem xs={12} sm={6} md={3}>
              <FormControl className={classes.green}>
                <InputLabel htmlFor="encomenda">Encomenda</InputLabel>
                <Input onChange={this.handleChange} name="encomenda" id="encomenda" />
              </FormControl>
            </GridItem>
          </GridContainer>
          <Button onClick={this.handleFilterTable} color="primary" autoFocus>
            Pesquisar
          </Button>
        </form>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchOperations);
